module.exports = __webpack_public_path__ + "static/media/supportMessagesSent_1000.00f9d65e.png";